import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39baf98e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddle-sales" }
const _hoisted_2 = { class: "top-selling-items-header" }
const _hoisted_3 = {
  key: 0,
  class: "view--summary"
}
const _hoisted_4 = {
  key: 1,
  class: "view--full"
}

import { computed, type ComputedRef } from 'vue'
import { SalesItem } from '@/entities/huddles'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faCircleDollar } from 'fontawesome/pro-regular-svg-icons'
import Typography from '@/components/Rain/Typography/Typography.vue'
import HuddleSalesItem from '@/mobile/src/views/appV4/huddles/HuddleSalesItem.vue'

interface Props {
    topSellingItems: SalesItem[]
    summaryView: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddleDetailsSalesPanel',
  props: {
    topSellingItems: {},
    summaryView: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const sortedTopSellers: ComputedRef<SalesItem[]> = computed(() => {
    return [...props.topSellingItems].sort((a, b) => {
        return a.count > b.count ? -1 : 1
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(FontAwesomeIcon), {
        icon: _unref(faCircleDollar),
        size: "xl"
      }, null, 8, ["icon"]),
      _createVNode(Typography, { variant: "subtitle1" }, {
        default: _withCtx(() => [
          _createTextVNode("Top Selling Items")
        ], undefined, true),
        _: 1
      })
    ]),
    (_ctx.summaryView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTopSellers.value.slice(0, 3), (salesItem, index) => {
            return (_openBlock(), _createBlock(HuddleSalesItem, {
              key: index,
              "item-name": salesItem.item,
              "item-count": salesItem.count,
              type: "summary"
            }, null, 8, ["item-name", "item-count"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTopSellers.value, (salesItem, index) => {
            return (_openBlock(), _createBlock(HuddleSalesItem, {
              key: index,
              "item-name": salesItem.item,
              "item-count": salesItem.count,
              type: "full"
            }, null, 8, ["item-name", "item-count"]))
          }), 128))
        ]))
  ]))
}
}

})